import { useTheme } from "styled-components";
import { Color } from "@/utils/theme";

const graphOptions = {
  responsive: true,
  layout: {
    padding: {
      top: 5,
    },
  },
  scales: {
    x: {
      display: false,
    },
    y: {
      display: false,
    },
  },
};

const useTrendGraph = (
  labels: string[],
  data: number[],
  percentage: number
) => {
  const theme = useTheme();

  const color: Color =
    percentage === 0 ? "warning" : percentage > 0 ? "success" : "error";

  const secondaryColor: Color =
    percentage === 0
      ? "warningLight"
      : percentage > 0
      ? "successLight"
      : "errorLight";

  const graphData = {
    labels,
    datasets: [
      {
        data,
        borderColor: theme.colors[color],
        borderWidth: 2,
        backgroundColor: theme.colors[secondaryColor],
        tension: 0.4,
        pointRadius: 0,
        fill: "origin",
      },
    ],
  };

  return { color, secondaryColor, graphData, graphOptions };
};

export default useTrendGraph;
